var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "channels-item",
      class: {
        healthy: _vm.isWhatsappChannel && _vm.isHealthy,
        dead: _vm.isWhatsappChannel && !_vm.isHealthy,
      },
    },
    [
      _c("div", { staticClass: "first", on: { click: _vm.goToDetail } }, [
        _c(
          "div",
          { staticClass: "icon-wrapper", on: { click: _vm.goToDetail } },
          [
            _vm.isBusiness
              ? _c("WhatsappBusinessIcon", {
                  attrs: { className: "channel-icon", color: "#FFFFFF" },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isV1
              ? _c("WhatsappV1", {
                  staticClass: "channel-icon",
                  attrs: { color: "#FFFFFF" },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isV2
              ? _c("WhatsappV2", {
                  staticClass: "channel-icon",
                  attrs: { color: "#FFFFFF" },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isV3
              ? _c("WhatsappV3Icon", {
                  staticClass: "channel-icon",
                  attrs: { color: "#FFFFFF" },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isInstagram
              ? _c("InstagramIcon", {
                  staticClass: "channel-icon",
                  attrs: { "special-background-mode": "" },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isMessenger
              ? _c("MessengerIcon", {
                  staticClass: "channel-icon",
                  attrs: { "special-background-mode": "" },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.smsPostacell
              ? _c("img", {
                  staticStyle: { "max-width": "50px" },
                  attrs: { src: "/static/img/postacell-logo.png" },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  followCursor: true,
                  placement: "bottom-end",
                  theme: _vm.isDarkMode ? "light-border" : "google",
                },
                expression:
                  "{\n                followCursor: true,\n                placement: 'bottom-end',\n                theme: isDarkMode ? 'light-border' : 'google',\n            }",
              },
            ],
            staticClass: "channel-name",
            attrs: {
              content: _vm.getChannelType + _vm.channel.name.toUpperCase(),
            },
            on: { click: _vm.goToDetail },
          },
          [_vm._v("\n            " + _vm._s(_vm.channel.name) + "\n        ")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _vm.whatsappModal && !_vm.isV3
            ? _c(
                "IconButton",
                {
                  attrs: {
                    "on-click": function () {
                      return _vm.$router.push(_vm.broadcastRequestURL)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            theme: _vm.isDarkMode ? "light-border" : "google",
                          },
                          expression:
                            "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                        },
                      ],
                      staticClass: "md-icon md-icon-style",
                      attrs: { content: _vm.$t("wp.broadcast.broadcast") },
                    },
                    [_vm._v("\n                campaign")]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("a-divider", { attrs: { type: "vertical" } }),
          _vm._v(" "),
          _vm.whatsappModal
            ? _c(
                "IconButton",
                { attrs: { "on-click": _vm.handleStartChatClick } },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            theme: _vm.isDarkMode ? "light-border" : "google",
                          },
                          expression:
                            "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                        },
                      ],
                      staticClass: "md-icon md-icon-style",
                      attrs: { content: "Start Chat" },
                    },
                    [_vm._v("\n                forum\n            ")]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.whatsappModal
            ? _c("IconButton", { attrs: { "on-click": _vm.openQRGenerator } }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                      },
                    ],
                    staticClass: "md-icon md-icon-style",
                    attrs: { content: "QR Oluştur" },
                  },
                  [_vm._v("\n                qr_code\n            ")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.smsModal
            ? _c("IconButton", { attrs: { "on-click": _vm.openSmsModal } }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                      },
                    ],
                    staticClass: "md-icon md-icon-style",
                    attrs: { content: "SEND SMS" },
                  },
                  [_vm._v("\n                forum\n            ")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          this.isInstagram || this.isMessenger
            ? _c(
                "IconButton",
                {
                  attrs: {
                    "on-click": function () {
                      return _vm.goToContacts()
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            theme: _vm.isDarkMode ? "light-border" : "google",
                          },
                          expression:
                            "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                        },
                      ],
                      staticClass: "md-icon md-icon-style",
                      attrs: { content: _vm.$t("ticimax.members") },
                    },
                    [_vm._v("\n                group")]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          this.isInstagram || this.isMessenger
            ? _c(
                "IconButton",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: {
                    "on-click": function () {
                      return _vm.goToFilteredTicket()
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            theme: _vm.isDarkMode ? "light-border" : "google",
                          },
                          expression:
                            "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                        },
                      ],
                      staticClass: "md-icon md-icon-style",
                      attrs: { content: _vm.$t("search.ticket") },
                    },
                    [_vm._v("\n                confirmation_number")]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("tour.startChat"),
            width: "1000px",
            footer: null,
          },
          on: { ok: _vm.closeModal },
          model: {
            value: _vm.showModal,
            callback: function ($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal",
          },
        },
        [
          _c("WhatsappContactList", {
            attrs: {
              channel: _vm.channel,
              "channel-id": _vm.channel._id,
              allowImport: false,
            },
            on: { close: _vm.closeModal },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: _vm.$t("tour.startChat"), footer: null },
          on: { ok: _vm.closeSmsModal },
          model: {
            value: _vm.smsStartChat,
            callback: function ($$v) {
              _vm.smsStartChat = $$v
            },
            expression: "smsStartChat",
          },
        },
        [
          _c(
            "div",
            { staticClass: "send-sms-v2" },
            [
              _c("SendSmsInput", {
                attrs: { "default-phone-number": _vm.phoneNumber },
                on: { sendSMS: _vm.sendSMS },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "qr-generator-modal",
          attrs: { title: "QR Generator", width: 1200, footer: null },
          on: { ok: _vm.closeQRGeneratorModal },
          model: {
            value: _vm.qrGeneratorModal,
            callback: function ($$v) {
              _vm.qrGeneratorModal = $$v
            },
            expression: "qrGeneratorModal",
          },
        },
        [
          _c("div", { staticStyle: { height: "700px" } }, [
            _c("iframe", {
              staticStyle: { width: "100%", height: "100%", border: "none" },
              attrs: {
                src: _vm.qrGeneratorURL,
                allow:
                  "camera; microphone; geolocation; fullscreen; autoplay; payment; vr; web-share; accelerometer; gyroscope; magnetometer; picture-in-picture; display-capture; clipboard-read; clipboard-write; usb; bluetooth; serial; hid",
                sandbox:
                  "allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock allow-orientation-lock allow-modals allow-downloads allow-popups-to-escape-sandbox allow-presentation allow-storage-access-by-user-activation allow-top-navigation allow-top-navigation-by-user-activation",
              },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }